import DesktopNavigation from "./desktop";
import MobileNavigation from "./mobile";
import { Desktop, MobileOrTablet } from '../media-queries'
import './styles.scss'

const CLASS_NAME="navigation"

function Navigation() {
    return <nav className={CLASS_NAME}>
        <Desktop>
            <DesktopNavigation />
        </Desktop>
        <MobileOrTablet>
            <MobileNavigation/>
        </MobileOrTablet>
    </nav>
}

export default Navigation;